import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyEditDialogStepsEnum} from '../../../enums/my-edit-dialog-steps.enum';
import {MyPriceApprovalModeEnum} from '../../../enums/my-price-approval-mode.enum';

/**
 *dialog step6 sections visibility controller
 *
 */
@Component({
    selector: 'app-projects-dialog-step6-sections-controller',
    templateUrl: './dialog-step6-sections-controller.component.html',
    styleUrls: ['./dialog-step6-sections-controller.component.scss']
})
export class ProjectsDialogStep6SectionsControllerComponent extends EditModalSectionBaseComponent implements OnInit, OnChanges {


    public stepsEnum = MyEditDialogStepsEnum;

    public sectionIsExpandedState = {
        endUser: true,
        project: true,
        employee: true,
        warrantyNotes: true
    };

    @Input() usePriceApprovalMode = MyPriceApprovalModeEnum.DISABLED;

    constructor(public  editModalService: EditModalService) {
        super(editModalService);
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public isInternalUser(): boolean {
        return false;
    }

    public isSupplyOrderActive(): boolean {
        return this.editModalService.isSupplyOrderActive();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.isActivePriceApprovalMode()) {
            this.sectionIsExpandedState = {
                endUser: false,
                project: false,
                employee: false,
                warrantyNotes: false
            };
        }
    }

    public isActivePriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.ACTIVE;
    }

    public isDisabledPriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.DISABLED;
    }


}
